<script setup>
/**
 * @fileoverview Label component based on shadcn-vue
 * @description Form label with consistent styling
 * @example
 * <Label for="email">Email</Label>
 */
import { Label as LabelPrimitive } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps({
  for: {
    type: String,
    default: undefined
  },
  asChild: {
    type: Boolean,
    default: false
  },
  class: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <LabelPrimitive
    :for="for"
    :as-child="asChild"
    :class="
      cn(
        'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        props.class
      )
    "
  >
    <slot />
  </LabelPrimitive>
</template>
